<div *ngIf="isMobile">
  <app-project-info-mobile [projectType]="projectTypeIn" [customerId]="customerIdIn" [quote]="quoteIn" (updated)="quoteUpdated($event)"></app-project-info-mobile>
</div>
<div *ngIf="!isMobile">
  <app-project-info-desktop [projectType]="projectTypeIn" [customerId]="customerIdIn" [quote]="quoteIn" (updated)="quoteUpdated($event)"></app-project-info-desktop>
</div>
